import React, { Component } from 'react';
import { Layout, Icon, Form, Row, Col } from 'antd';
import moment from 'moment';
import './Header.css';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

const { Header } = Layout;
class Headers extends Component {
  logout = () => {
    this.props.logoutCallBack();
  }

  componentWillMount() {
    this.timer = setInterval(() => {
      this.setState({ date: new Date() });
    }, 1000);
  }

  handChangeLanguage = (value) => {
    let currentLocale = value
    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: require(`../locales/${currentLocale}`)
      }
    });
    sessionStorage.setItem("language", currentLocale);
    window.location.reload();
  }

  logout = () => {
    this.props.logoutCallBack(this.props.adultControlValue)
  }

  render() {
    const boldText = {
      fontWeight: "bold"
    }
    return (
      <div>
        <Header style={{ background: '#fff', padding: 25, height: 85, lineHeight: 1.8, fontSize: 15 }}>
          <Row>
            <Col span={12}>{intl.get('welcome')}！<span style={boldText}>{sessionStorage.getItem("userName")}</span></Col>
            <Col span={10}><Icon type="clock-circle"></Icon>{moment().format('YYYY-MM-DD HH:mm:ss')}</Col>
            {/* <Col span={4}>
                <Select defaultValue={sessionStorage.getItem('language')} onChange ={this.handChangeLanguage}>
                  <Option value="en-US">English</Option>
                  <Option value="zh-CN">中文</Option>
                </Select>
                </Col> */}

            <Col span={2}><a onClick={this.logout}>{intl.get("logout")}</a></Col>
            <Col span={24}>{intl.get("totalCa")}<span style={boldText}>{this.props.categoryList.length}</span>&nbsp;&nbsp;
                     {intl.get("totalCh")}<span style={boldText}>{this.props.totalCount}</span>
            </Col>
          </Row>
        </Header>
      </div>
    );
  }
}

const mapState = (state) => {
  return {
    categoryList: state.clientLink.categoryList,
    totalCount: state.clientLink.totalCount,
    clientHeight: state.clientLink.clientHeight,
    adultControlValue : state.clientLink.adultControlValue,
  }
}

const mapDispatch = (dispatch) => {
  return {
  }
}

export default connect(mapState, mapDispatch)(Form.create()(Headers));


// WEBPACK FOOTER //
// ./src/layouts/Headers.js